<template>
    <div class="mdrawer">
        <el-row :gutter="20" class="mstyle_first">
            <el-col :span="4" class="m-th">姓名</el-col>
            <el-col :span="8" v-if="personMemberInfo.name" class="m-td">{{personMemberInfo.name}}</el-col>
            <el-col :span="8" v-else>&nbsp;</el-col>
            <el-col :span="4" class="m-th">昵称</el-col>
            <el-col :span="8" class="m-td border-right-style">{{personMemberInfo.nickname}}</el-col>
        </el-row>
        <el-row :gutter="20" class="mstyle_s">
            <el-col :span="4" class="m-th">性别</el-col>
            <el-col :span="8" class="m-td">{{personMemberInfo.sex}}</el-col>
            <el-col :span="4" class="m-th">手机号</el-col>
            <el-col :span="8" class="m-td border-right-style">
              <phone-com
              :comPhone="personMemberInfo.phone"
              :vagaryPhone="personMemberInfo.vagary_phone"
              style="display: inline-block"
            />
            </el-col>
        </el-row>
        <el-row :gutter="20" class="mstyle_first">
             <el-col :span="4" class="m-th">注册时间</el-col>
            <el-col :span="8" class="m-td">{{personMemberInfo.regtime}}</el-col>
            <el-col :span="4" class="m-th">用户ID</el-col>
            <el-col :span="8" class="m-td border-right-style">{{personMemberInfo.id}}</el-col>
        </el-row>
        <el-row :gutter="20" class="mstyle_s">
            <el-col :span="4" class="m-th">注册来源</el-col>
            <el-col :span="8" class="m-td">{{personMemberInfo.user_from}}</el-col>
            <el-col :span="4" class="m-th ">所属业务</el-col>
            <el-col :span="8" v-if="personMemberInfo.business" class="m-td border-right-style">{{personMemberInfo.business.username}}</el-col>
            <el-col :span="8" v-else>&nbsp;</el-col>
        </el-row>
        <el-row :gutter="20" class="mstyle_first">
            <el-col :span="4" class="m-th">是否同意须知</el-col>
            <el-col :span="8" class="m-td">{{personMemberInfo.auth}}</el-col>
            <el-col :span="4" class="m-th">同意时间</el-col>
            <el-col :span="8" v-if="personMemberInfo.agree_at" class="m-td border-right-style">{{personMemberInfo.agree_at}}</el-col>
            <el-col :span="8" v-else>&nbsp;</el-col>
        </el-row>
         <el-row :gutter="20" class="mstyle_s lbottom">
            <el-col :span="4" class="m-th">客户等级</el-col>
            <el-col :span="8" class="m-td">{{personMemberInfo.level}}</el-col>
            <el-col :span="4" class="m-th">会员到期时间</el-col>
            <el-col :span="8" v-if="personMemberInfo.user_identify_outed_at" class="m-td border-right-style">{{personMemberInfo.user_identify_outed_at}}</el-col>
            <el-col :span="8" v-else>&nbsp;</el-col>
        </el-row>
    </div>
</template>

<script>
import PhoneCom from "common/PhoneCom";
export default {
  name: 'MemberInfo',
  props: {phone: String},
  components: { PhoneCom },
  data () {
    return {
      personMemberInfo: {}
    }
  },
  watch: {
    phone: function (val) {
      if (val) this.watchMemberInfo(val)
    }
  },
  methods: {
    watchMemberInfo (phone) {
      this.$axios.post('api/thread/member_info', {phone: phone}).then(({data}) => {
        if (data.code === 1) {
          this.personMemberInfo = data.data
        }
      }).catch()
    }
  }
}
</script>
<style scoped>
.mstyle_first {
  border: 1px solid #ccc;
  border-bottom: none;
}

.mstyle_first > * {
  border-right: 1px solid #ccc;
  white-space: nowrap;
}

.mstyle_s {
  border: 1px solid #ccc;
  border-bottom: none;
}

.mstyle_s > * {
  border-right: 1px solid #ccc;
  white-space: nowrap;
}

.m-th {
  height: 42px;
  line-height: 42px;
  padding: 0 5px;
  color: #909399;
  background: #fafafa;
}

.m-td {
  height: 42px;
  line-height: 42px;
  padding: 0 5px;
}

.lbottom  {
  border-bottom: 1px solid #ccc;
}

.border-right-style{
  border-right: none;
}
</style>



// WEBPACK FOOTER //
// src/common/MemberInfo.vue